import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Field,reduxForm,formValueSelector,submit } from 'redux-form';
import renderTextField from '../../components/MaterialUi/renderTextField';
import renderCheckbox from '../../components/MaterialUi/renderCheckbox';
import RFAutoCompleteField from '../../components/ReduxFormComps/RFAutoCompleteField';
import RFDatePickerField from '../../components/ReduxFormComps/RFDatePickerField'
import ContainerRowSpace from '../../components/common/ContainerRowSpace'
import RFSelectWithOverrideComponent from '../../components/ReduxFormComps/RFSelectWithOverrideComponent'
import RFTextOverrideRequireField from '../../components/ReduxFormComps/RFTextOverrideRequireField'
import Paper from 'material-ui/Paper'

import * as actions from '../../redux/projApollo/actions';
import * as actConfDlgActions from '../../redux/actConfDialog/actions';
import { checkboxLabel } from './CheckboxUtil';
import { dataSourceConfig } from './common'
import ActionConfirmDialog from '../../components/ActionConfirmDialog';
import { validate } from './others/validation'

const styles = {
    textFieldStyle: {
        width: '320px'
    } 
}

const validTotalAmount=props=>{
    const { projApollo,hdrMainInvTotal } = props;
    const mainInvTotal=parseFloat(hdrMainInvTotal)
    return mainInvTotal===parseFloat(projApollo.totalSumOfItemCharge)?true:false;
}

const renderSubmitButton=props=>{
    const { pristine,submitting,projApollo,isPdfIssue,invalid } = props;

    if (isPdfIssue){
        return <button type="submit" onClick={()=> props.submitOpenActionDialog()} className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit As Invalid Invoice</button>; 
    }else {
        if (projApollo.apolloItems.length > 0 && !invalid) {
            const displayAlert=validTotalAmount(props)?null:(
                    <div className="alert alert-warning" role="alert">
                        WARNING! Make sure your Label E is tally with Total of Column M.
                    </div>
            )
            return (
                <div>
                    <button type="submit" onClick={()=> props.submitOpenActionDialog()} className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit Your Answer</button>
                    {displayAlert}
                </div>    
            )
        }
    }
    return null;
}

const renderVendorInfo=props=>{
    const { projApollo } = props;
    const { invoiceVendor } = projApollo;

    if (invoiceVendor){
        return (
            <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><strong><small>Code:</small></strong> <u><small>{invoiceVendor.code}</small></u></li>
                    <li className="breadcrumb-item"><strong><small>Name:</small></strong> <u><small>{invoiceVendor.desc}</small></u></li>
                    <li className="breadcrumb-item"><strong><small>Type:</small></strong> <u><small>{invoiceVendor.type_of_invoice}</small></u></li>
                </ol>
            </nav>
        )
    }
}

class InvoiceHeaderForm extends React.Component {
    
    render(){
        const { handleSubmit,pristine,submitting,projApollo,
            isOverrideHdrMainAcctNo,isOverrideHdrCustCompName,actConfDialog,
            jwt,taskAcceptedInfoId
         } = this.props;
        
        if (!projApollo.invoiceVendorsLoaded){
            this.props.populateVendorsList();
        }
    
        if (projApollo.invoiceSubmitted) {
            return <Redirect to='/projectApollo/submittedForm' />;
        }

        return (
            <div>
                <Paper>
                    <div className='container'>
                    <form onSubmit={handleSubmit} > 
                        <div className="row">
                            <div className='col-sm'>
                                <Field name="isPdfIssue" 
                                component={renderCheckbox} 
                                label="Invalid PDF / Missing Pages / Not load" />
                            </div>
                        </div> 
                        <ContainerRowSpace />
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    label="Label A Header Vendor Code"
                                    name="hdrVendorCode"
                                    dataSource={projApollo.invoiceVendors}
                                    dataSourceConfig={dataSourceConfig}
                                    component={RFAutoCompleteField}
                                    fullWidth={true}
                                />
                                {renderVendorInfo(this.props)}
                            </div>
                        </div>
                        <ContainerRowSpace />
                        <div className="row">
                            <div className='col-sm'>
                                <RFSelectWithOverrideComponent 
                                    label="Label B Header Main Account Number"
                                    fieldName="hdrMainAcctNo"
                                    datas={projApollo.invoiceAcctNos}
                                    dataDict={{code: 'code', desc: 'desc'}}
                                    customStyle={styles.textFieldStyle}
                                    overrideCheckBoxFieldName='isOverrideHdrMainAcctNo'
                                    overrideCheckBoxLabel={checkboxLabel(isOverrideHdrMainAcctNo,'Label B')}
                                    isOverrideHdrMainAcctNo={this.props.isOverrideHdrMainAcctNo}
                                />
                            </div>
                        </div> 
                        <ContainerRowSpace />
                        <div className="row">
                            <div className='col-sm'>
                                <RFSelectWithOverrideComponent 
                                    label="Label C Header Customer Company Name"
                                    fieldName="hdrCustCompName"
                                    datas={projApollo.invoiceCustNames}
                                    dataDict={{code: 'code', desc: 'desc'}}
                                    customStyle={styles.textFieldStyle}
                                    overrideCheckBoxFieldName='isOverrideHdrCustCompName'
                                    overrideCheckBoxLabel={checkboxLabel(isOverrideHdrCustCompName,'Label C')}
                                    isOverrideHdrCustCompName={this.props.isOverrideHdrCustCompName}
                                />
                            </div>
                        </div>
                        <ContainerRowSpace />
                        <div className="row">
                            <div className='col-sm'>
                                <RFTextOverrideRequireField 
                                    label='Label D Header Main Invoice Number'
                                    fieldName='hdrMainInvNo'
                                    customStyle={styles.textFieldStyle}
                                    overrideCheckBoxFieldName='isOverrideHdrMainInvNoIfNotFound'
                                    overrideCheckBoxLabel={'Label D field not found in Document'}
                                    isOverrideHdrMainInvNoIfNotFound={this.props.isOverrideHdrMainInvNoIfNotFound}
                                />   
                            </div>    
                        </div> 
                        <ContainerRowSpace />
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    name="hdrMainInvTotal"
                                    component={renderTextField}
                                    label="Label E Header Main Invoice Total"
                                    type="number"
                                    style={styles.textFieldStyle}
                                    />
                            </div>
                        </div>
                        <ContainerRowSpace />
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    name="hdrInvDate"
                                    component={RFDatePickerField}
                                    label="Label F Header Invoice Date"
                                    inputDateFormat='MM/DD/YYYY'
                                    style={styles.textFieldStyle}
                                    inputNote="US date format MM/DD/YYYY"
                                />    
                            </div> 
                        </div>
                        <ContainerRowSpace />
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    name="hdrPayDate"
                                    component={RFDatePickerField}
                                    label="Label G Header Payment Date"
                                    inputDateFormat='MM/DD/YYYY'
                                    style={styles.textFieldStyle}
                                    inputNote="US date format MM/DD/YYYY"
                                />     
                            </div>    
                        </div>
                        <ContainerRowSpace />
                        <div className="row">
                            <div className='col-sm'> 
                                {projApollo.error?(
                                        <div className="alert alert-danger" role="alert">
                                        {projApollo.error}
                                        </div>
                                ):null}
                            </div>
                        </div>    
                    </form>
                        <div className="row">
                            <div className='col-sm'> 
                                {renderSubmitButton(this.props)}
                            </div>
                        </div>   
                        <ContainerRowSpace />
                        <div className="row">
                            <div className='col-sm'> 
                                <ActionConfirmDialog 
                                        title={'Invoice Data Extraction'}
                                        message={'Please do double check and confirm all your inputs before click submit.'}
                                        submitFunc={this.props.submitReduxForm}
                                /> 
                            </div>
                    </div>   
                    </div>
                </Paper>        
            </div>    
        )
    }
}

const submitMethod = (values, dispatch, props) => {
    const { jwt,taskAcceptedInfoId } = props;
    props.submitCloseActionDialog()
    props.invoiceSubmission(jwt,taskAcceptedInfoId,values);
}

const InvoiceHeaderReduxForm = reduxForm({
    form: 'invoiceHeaderForm',
    validate,
    onSubmit: submitMethod
})(InvoiceHeaderForm)

const selector = formValueSelector('invoiceHeaderForm')

const mapStateToProps = (state, ownProps) => {
    return {
        projApollo: state.projApollo,
        isPdfIssue: selector(state, 'isPdfIssue'),
        isOverrideHdrMainAcctNo: selector(state, 'isOverrideHdrMainAcctNo'),
        isOverrideHdrCustCompName: selector(state, 'isOverrideHdrCustCompName'),
        isOverrideHdrMainInvNoIfNotFound: selector(state, 'isOverrideHdrMainInvNoIfNotFound'),
        hdrMainInvTotal: selector(state, 'hdrMainInvTotal'),
        actConfDialog: state.actConfDialog
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      populateVendorsList: () => {
         dispatch(actions.populateVendorsList())  
      },
      refreshAcctNos: (jwt,vendorCode) => {
        dispatch(actions.refreshAcctNos(jwt,vendorCode))  
      },
      refreshCustNames: (jwt,vendorCode,acctNo) => {
        dispatch(actions.refreshCustNames(jwt,vendorCode,acctNo))  
      },
      refreshChargeDescs: (jwt,vendorCode,acctNo) => {
        dispatch(actions.refreshChargeDescs(jwt,vendorCode,acctNo))  
      },
      refreshServiceAddress: (jwt,vendorCode,acctNo) => {
        dispatch(actions.refreshServiceAddress(jwt,vendorCode,acctNo))  
      },
      invoiceSubmission: (jwt,taskAcceptedInfoId,invoiceHeader) => {
        dispatch(actions.invoiceSubmission(jwt,taskAcceptedInfoId,invoiceHeader))  
      },
      validateVendorNAcctNo: (jwt,vendorCode,acctNo) => {
        dispatch(actions.validateVendorNAcctNo(jwt,vendorCode,acctNo))  
      },
      clearValidation: () => {
        dispatch(actions.clearValidation())  
      },
      selectedInvVendor: (code,vendors) => {
        dispatch(actions.selectedInvVendor(code,vendors))  
      },
      clearInvVendor: () => {
        dispatch(actions.clearInvVendor())  
      },
      clearAllInvoiceItems: () => {
        dispatch(actions.clearAllInvoiceItems())  
      },
      setInvAcctNo: (invAcctNo)=> {
        dispatch(actions.setInvAcctNo(invAcctNo))     
      },
      clearInvAcctNo: ()=> {
        dispatch(actions.clearInvAcctNo())    
      },
      saveInvoiceHeader: (invoiceHeader)=> {
        dispatch(actions.saveInvoiceHeader(invoiceHeader))    
      },
      submitOpenActionDialog: ()=> {
        dispatch(actConfDlgActions.openDialog())    
      },
      submitCloseActionDialog: ()=> {
        dispatch(actConfDlgActions.closeDialog())    
      },
      submitReduxForm: ()=>{
        dispatch(submit('invoiceHeaderForm'))
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(InvoiceHeaderReduxForm);


// WEBPACK FOOTER //
// ./src/views/ProjectApollo/InvoiceHeaderForm.js